export const STAMP = '8/3/2024'